<nav class="navbar navbar-light navbar-expand-lg ">
    <!-- Navbar content -->
    <a class="navbar-brand" [routerLink]="['/']">
        <img src="assets/img/logo.png" style="height: 50px;" />
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/']">Inicio</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="scroll(comoFunciona)" href="javascript:void(0)">¿Cómo funciona el
                    tratamiento?</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="scroll(ventajas)" href="javascript:void(0)">Ventajas</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="scroll(diferenciasPaciente)" href="javascript:void(0)">¿Cuáles son las
                    diferencias?</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="scroll(encontrarDoctor)" href="javascript:void(0)">Encuentre a su
                    doctor</a>
            </li>
        </ul>
    </div>
</nav>